import { LOCAL_STORAGE_KEY } from "@/constants/localStorageKey";
import useAppStore from "@/context/store";
import { useDebounceFn } from "ahooks";
import { Button, Form } from "antd";
import { useRef, useState } from "react";
import { createBoard } from "../../../services";
import HBIcon from "../../HBIcon";
import HBInput from "../../HBInput";
import HBMessage from "../../HBMessage";
import HBTabButton from "../../HBTabButton";
import styles from "../form.module.less";
import CategoriesSelect from "../shared/CategoriesSelect";
import CollectionsSelect from "../shared/CollectionsSelect";
import PrivateRadio from "../shared/PrivateRadio";
import rules from "../shared/rules";

// 创建表单
export default function Creator({
  isPro,
  isDesigner,
  categories,
  defaultData = {},
  onOk,
  onCancel,
  collectionId,
  collections,
  ...props
}) {
  const formref = useRef(null);
  const [okDisabled, setDisabled] = useState(true);

  const { run: onFinish } = useDebounceFn(
    async function (values) {
      const data = await createBoard({
        ...values,
        title: values.title.trim(),
        creation: (values.creation || false).toString(),
        is_private: values.is_private ? "1" : "0",
      });

      if (data.err) return;
      onOk && onOk(data.board);
      HBMessage.success("画板新建成功");
      const lastBoards = await useAppStore.getState().refreshLastBoards();
      if (lastBoards) {
        try {
          window.localStorage.setItem(
            LOCAL_STORAGE_KEY.UPDATE_LAST_BOARDS,
            JSON.stringify(lastBoards)
          );
        } catch (e) {
          console.error("设置更新最近采集失败");
        }
      }
    },
    {
      wait: 300,
      leading: true,
    }
  );

  return (
    <Form
      ref={formref}
      className={styles.form}
      name="basic"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      initialValues={{
        ...defaultData,
        ...(collectionId ? { collection_id: +collectionId } : null),
        is_private: false,
        creation: false,
      }}
      autoComplete="off"
      onValuesChange={(changevalue, allvalue) => {
        props.onChange && props.onChange(changevalue, allvalue);
        if (allvalue.title) {
          setDisabled(false);
        } else {
          setDisabled(true);
        }
      }}
      onFinish={onFinish}
    >
      {isDesigner ? (
        <Form.Item
          name="creation"
          wrapperCol={{ flex: 1 }}
          style={{
            marginBottom: "12px",
          }}
        >
          <SwitchCreation />
        </Form.Item>
      ) : null}

      <Form.Item
        name="title"
        wrapperCol={{ flex: 1 }}
        rules={rules.title}
        style={{
          marginBottom: "12px",
        }}
      >
        <HBInput placeholder="标题" autoFocus />
      </Form.Item>

      <Form.Item
        name="category"
        wrapperCol={{ flex: 1 }}
        rules={rules.category}
        style={{
          marginBottom: "12px",
        }}
      >
        <CategoriesSelect categories={categories} />
      </Form.Item>

      {collections.length > 0 ? (
        <Form.Item
          name="collection_id"
          wrapperCol={{ flex: 1 }}
          rules={rules.collection_id}
          style={{
            marginBottom: "12px",
          }}
        >
          <CollectionsSelect collections={collections} />
        </Form.Item>
      ) : null}

      <Form.Item
        name="is_private"
        wrapperCol={{ flex: 1 }}
        valuePropName="checked"
      >
        <PrivateRadio isPro={isPro} />
      </Form.Item>

      <Form.Item noStyle>
        <div className="vertical-center">
          <div style={{ flex: 1, textAlign: "right" }}>
            <Button
              type="text"
              style={{ marginRight: "8px" }}
              onClick={() => {
                onCancel && onCancel();
              }}
            >
              取消
            </Button>
            <Button type="primary" htmlType="submit" disabled={okDisabled}>
              创建画板
            </Button>
          </div>
        </div>
      </Form.Item>
    </Form>
  );
}

/**
 * 切换是否原创
 * @returns
 */
function SwitchCreation(props) {
  const [creation, setCreation] = useState(false);
  return (
    <div>
      <HBTabButton
        {...props}
        onChange={(option, value) => {
          setCreation(value);
          props.onChange && props.onChange(value);
        }}
        options={[
          { value: false, name: "普通画板" },
          { value: true, name: "原创画板" },
        ]}
      />
      {creation ? (
        <div className={styles.desc}>
          <HBIcon type="ic_Warning" />
          原创画板只能上传原创作品，不能收集转采的采集
        </div>
      ) : null}
    </div>
  );
}
